import React, { useMemo } from 'react';
import cx from 'classnames';
import { Button } from 'reactstrap';

import { Icon, Loading } from 'js/components';
import { faPlug, faEdit, faTrashAlt } from '@fortawesome/pro-regular-svg-icons';
import { CONNECTOR_SERVICES } from 'js/data/connectors';
import styles from './ConnectorSettings.module.scss';

function ConnectorType({ type }) {
  const service = useMemo(
    () => CONNECTOR_SERVICES.find((service) => service.id === type),
    [type]
  );

  return (
    <div className={styles['service-card-mini']}>
      <span className={styles['service-card-icon']}>
        <img src={service.logo} alt={service.name} />
      </span>
      <span className={cx(styles['service-card-title'], 'line-clamp-2')}>
        {service.name}
      </span>
    </div>
  );
}

function ConnectorList({
  connectors,
  isLoading,
  onEdit,
  onDelete,
  onTest,
  onCreateNew,
}) {
  if (isLoading) {
    return <Loading />;
  }

  if (connectors.length === 0) {
    return (
      <div className="media text-muted mt-4 mb-4">
        <Icon icon={faPlug} size="4x" className="mr-3" fixedWidth />
        <div className="media-body">
          <p>No connectors configured</p>
          <p>
            Add a connector to integrate with external services and sync data.
          </p>
          <Button color="primary" onClick={onCreateNew}>
            Add Your First Connector
          </Button>
        </div>
      </div>
    );
  }

  //   <div className="text-center py-4">
  //   <div className="mb-3">
  //     <i className="fas fa-plug fa-3x text-muted"></i>
  //   </div>
  //   <h5 className="text-muted">No connectors configured</h5>
  //   <p className="text-muted">
  //     Add a connector to integrate with external services and sync data.
  //   </p>
  //   <Button color="primary" onClick={onCreateNew}>
  //     Add Your First Connector
  //   </Button>
  // </div>

  return (
    <div className={styles['connector-list']}>
      {connectors.map((connector) => (
        <div key={connector.id} className={styles['connector']}>
          <div className={styles['connector-type']}>
            <ConnectorType type={connector.type} />
          </div>
          <div className={styles['connector-name']}>{connector.name}</div>
          <div className={styles['connector-actions']}>
            <Button
              color="info"
              size="sm"
              title="Test Connection"
              outline
              className="btn-inline px-2"
              onClick={() => onTest(connector.id)}
            >
              <Icon icon={faPlug} fixedWidth />
            </Button>
            <Button
              color="info"
              size="sm"
              title="Edit Connector"
              outline
              className="btn-inline px-2"
              onClick={() => onEdit(connector)}
            >
              <Icon icon={faEdit} fixedWidth />
            </Button>
            <Button
              color="info"
              size="sm"
              className="btn-inline px-2"
              outline
              title="Delete Connector"
              onClick={() => onDelete(connector)}
            >
              <Icon icon={faTrashAlt} fixedWidth />
            </Button>
          </div>
        </div>
      ))}
    </div>
  );
}

export default ConnectorList;
